import { c as _c } from "react/compiler-runtime";
import { Button, Heading, Icon, Modal, ModalBody, ModalFooter, ModalHeader, TextPassage } from '@petsmart-ui/sparky';
import { useEffect } from 'react';
import { trackUpdateAutoshipAddress, trackViewUpdateAutoshipAddressModal } from '@libs/analytics';
import './ConfirmAutoshipDefaultAddressChangeModal.scss';
type ConfirmAutoshipDefaultAddressChangeModalProps = {
  isActive: boolean;
  isFraudValidationNeeded?: boolean;
  onClose: () => void;
  onKeepExistingAddress: () => void;
  onUpdateAddress: () => void;
  loading?: 'keep' | 'update';
};
const componentClassname = 'update-autoship-address-modal';
const KEEP_BUTTON_TEXT = 'No, keep existing address';
const UPDATE_BUTTON_TEXT = 'Yes, update address';
const SITE_SECTION = 'my account | addresses';
export function ConfirmAutoshipDefaultAddressChangeModal(t0) {
  const $ = _c(38);
  const {
    isActive,
    isFraudValidationNeeded: t1,
    onClose,
    onKeepExistingAddress,
    onUpdateAddress,
    loading
  } = t0;
  const isFraudValidationNeeded = t1 === undefined ? false : t1;
  let t2;
  let t3;
  if ($[0] !== isActive) {
    t2 = () => {
      if (isActive) {
        trackViewUpdateAutoshipAddressModal(SITE_SECTION);
      }
    };
    t3 = [isActive];
    $[0] = isActive;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== onClose) {
    t4 = () => {
      trackUpdateAutoshipAddress({
        linkText: "close",
        siteSection: SITE_SECTION
      });
      onClose();
    };
    $[3] = onClose;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleClose = t4;
  const t5 = isFraudValidationNeeded ? "Update address" : "Update Autoship address";
  let t6;
  if ($[5] !== t5) {
    t6 = <Heading tagName="h5" className={`${componentClassname}__heading`}>{t5}</Heading>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon name="x" />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== handleClose) {
    t8 = <button className="sparky-c-button sparky-c-modal__close-button sparky-c-button--bare sparky-c-button--circle" aria-pressed="true" type="button" onClick={handleClose} data-testid="update-autoship-modal-close-btn">{t7}</button>;
    $[8] = handleClose;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t8) {
    t9 = <ModalHeader className={`${componentClassname}__header`} closeButtonText="close">{t6}{t8}</ModalHeader>;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = isFraudValidationNeeded ? "Updating your address will save it as a new address in your account. Existing Autoship orders will continue using their current shipping address." : "Your previous default address is linked to one or more Autoship orders. Would you like to use your new default address for those Autoship orders?";
  let t11;
  if ($[13] !== t10) {
    t11 = <ModalBody className={`${componentClassname}__body`}><TextPassage className={`${componentClassname}__text`}>{t10}</TextPassage></ModalBody>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== onKeepExistingAddress) {
    t12 = () => {
      trackUpdateAutoshipAddress({
        linkText: KEEP_BUTTON_TEXT.toLowerCase(),
        siteSection: SITE_SECTION
      });
      onKeepExistingAddress();
    };
    $[15] = onKeepExistingAddress;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = loading === "keep" && !isFraudValidationNeeded;
  const t14 = loading === "keep" && !isFraudValidationNeeded;
  const t15 = isFraudValidationNeeded ? "Cancel" : KEEP_BUTTON_TEXT;
  let t16;
  if ($[17] !== t12 || $[18] !== t13 || $[19] !== t14 || $[20] !== t15) {
    t16 = <Button type="button" onClick={t12} loading={t13} disabled={t14} text={t15} />;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== onUpdateAddress) {
    t17 = () => {
      trackUpdateAutoshipAddress({
        linkText: UPDATE_BUTTON_TEXT.toLowerCase(),
        siteSection: SITE_SECTION
      });
      onUpdateAddress();
    };
    $[22] = onUpdateAddress;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  const t18 = loading === "update" || isFraudValidationNeeded && loading === "keep";
  const t19 = loading === "update" || isFraudValidationNeeded && loading === "keep";
  const t20 = isFraudValidationNeeded ? "Save new address" : UPDATE_BUTTON_TEXT;
  let t21;
  if ($[24] !== t17 || $[25] !== t18 || $[26] !== t19 || $[27] !== t20) {
    t21 = <Button variant="primary" onClick={t17} loading={t18} disabled={t19} text={t20} />;
    $[24] = t17;
    $[25] = t18;
    $[26] = t19;
    $[27] = t20;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== t16 || $[30] !== t21) {
    t22 = <ModalFooter data-testid="update-autoship-modal-footer" className={`${componentClassname}__footer`} alignEnd={true}><div className={`${componentClassname}__button-group`}>{t16}{t21}</div></ModalFooter>;
    $[29] = t16;
    $[30] = t21;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== handleClose || $[33] !== isActive || $[34] !== t11 || $[35] !== t22 || $[36] !== t9) {
    t23 = <Modal dismissible={true} isActive={isActive} className={componentClassname} onClose={handleClose}>{t9}{t11}{t22}</Modal>;
    $[32] = handleClose;
    $[33] = isActive;
    $[34] = t11;
    $[35] = t22;
    $[36] = t9;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  return t23;
}